import PropTypes from 'prop-types';
import HeaderMenu from './HeaderMenu';

const HeaderMenuContainer = ({ headerMenus }) => (
  <div className="menu menu--main menu--header">
    <ul className="menu__list menu__list--main">
      {headerMenus.map(menu => (
        <HeaderMenu key={menu.name} href={menu.href} name={menu.name} items={menu.items} />
      ))}
    </ul>
  </div>
);

HeaderMenuContainer.propTypes = {
  headerMenus: PropTypes.array.isRequired
};

export default HeaderMenuContainer;
